"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncCorpusList = void 0;
const axios_1 = __importDefault(require("axios"));
const PayloadUtils_1 = require("../common/PayloadUtils");
const getApiHost_1 = require("./getApiHost");
const logger_1 = require("./logger");
function syncCorpusList() {
    return __awaiter(this, void 0, void 0, function* () {
        let snackbar = logger_1.logger.snackbar('正在同步词库列表', [], -1, false);
        let url = (0, getApiHost_1.getApiHost)() + '/list';
        try {
            let res = yield axios_1.default.get(url);
            if (res.status < 400) {
                snackbar.close();
                if (res.data.status == PayloadUtils_1.ListStatus.OK) {
                    logger_1.logger.snackbar('词库同步成功');
                    return res.data.body;
                }
                else {
                    throw new Error(res.data.message);
                }
            }
            else {
                throw new Error(res.statusText);
            }
        }
        catch (e) {
            snackbar.close();
            logger_1.logger.snackbar(`词库同步失败。刷新页面以重试。${e}`);
        }
    });
}
exports.syncCorpusList = syncCorpusList;
